import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { FormattedMessage } from "react-intl";
import { getFrequency } from "sr/utils/api/masterData/getFrequency";

type Props = {
  data: { frequency?: string };
  HandleDataProps: (payload: { frequency: string }) => void;
  externalErrorId?: string;
};

const RequirementFrequencyChange = forwardRef(({ data, HandleDataProps, externalErrorId }: Props, ref) => {
  const [frequency, setFrequency] = useState("");
  const [errorId, setErrorId] = useState<string>("");
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    setFrequency(data?.frequency || "");
  }, [data?.frequency]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getFrequency();
        if (res?.success && Array.isArray(res.data)) {
          const mapped = res.data.map((item: any) => ({
            value: item.value,
            label: item.label,
          }));
          setOptions(mapped);
        }
      } catch {}
    };
    load();
  }, []);

  useEffect(() => {
    HandleDataProps({ frequency });
  }, [frequency]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!frequency?.trim()) {
        setErrorId('INPUT.VALIDATION.REQUIREMENT.FREQUENCY');
        return false;
      }
      setErrorId("");
      return true;
    },
    submitForm: () => ({ frequency }),
  }));

  return (
    <div>
      <p className="pt-4 text-base">Frequency</p>
      <DropDown
        value={frequency}
        onChange={(e) => setFrequency(e.target.value)}
        name="frequency"
        className="h-11 mt-2 border border-zinc-800 rounded-lg"
        error={externalErrorId || errorId}
      >
        <option value="">Select Frequency</option>
        {options.map((opt, idx) => (
          <option key={idx} value={opt.value}>
            <FormattedMessage id={opt.label} defaultMessage={opt.label} />
          </option>
        ))}
      </DropDown>
    </div>
  );
});

export default RequirementFrequencyChange;
